import {slimCustom} from "../../helpers/slim-select.jquery.js";

document.addEventListener('oneditformload', onLoad)
function onLoad() {
    new SlimSelect(slimCustom.apply($<HTMLSelectElement>(".dop-titles")[0]));

}